import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SignificantSalesChangesState {
  isChart: boolean;
  dollars: boolean;
  units: boolean;
  lineChart: boolean;
  top_inc: string;
  top_dec: string;
}

export const initialState: SignificantSalesChangesState = {
  isChart: true,
  dollars: true,
  units: false,
  lineChart: true,
  top_inc: "2",
  top_dec: "2",
};

export const significantSalesChangesSlice = createSlice({
  name: "salesBreakout",
  initialState,
  reducers: {
    changeDollarsSignificantSalesChanges: (
      state: SignificantSalesChangesState,
      action: PayloadAction<boolean>
    ) => {
      state.dollars = action.payload;
    },
    changeUnitsSignificantSalesChanges: (
      state: SignificantSalesChangesState,
      action: PayloadAction<boolean>
    ) => {
      state.units = action.payload;
    },
    changeIncSignificantSalesChanges: (
      state: SignificantSalesChangesState,
      action: PayloadAction<string>
    ) => {
      state.top_inc = action.payload;
    },

    changeDecSignificantSalesChanges: (
      state: SignificantSalesChangesState,
      action: PayloadAction<string>
    ) => {
      state.top_dec = action.payload;
    },

    toggleChartSignificantSalesChanges: (
      state: SignificantSalesChangesState,
      action: PayloadAction<boolean>
    ) => {
      state.isChart = action.payload;
    },
    toggleChartTypeSignificantSalesChanges: (
      state: SignificantSalesChangesState,
      action: PayloadAction<boolean>
    ) => {
      state.lineChart = action.payload;
    },
  },
});

export const {
  changeDollarsSignificantSalesChanges,
  changeUnitsSignificantSalesChanges,
  toggleChartSignificantSalesChanges,
  toggleChartTypeSignificantSalesChanges,
  changeDecSignificantSalesChanges,
  changeIncSignificantSalesChanges,
} = significantSalesChangesSlice.actions;
